import React from 'react'
import headshot from '../assets/headshot.jpg'
import { TypeAnimation } from 'react-type-animation';
import { GrDocumentPdf } from "react-icons/gr";

const Hero = () => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-[1200px] mx-auto py-8 bg-black'>
        
        <div className='my-auto mx-auto w-[300px] h-auto lg:w-[400px] '>
            <img src={headshot} alt="headshot" className='rounded-3xl ring ring-blue-200'/>
        </div>

        <div className='col-span-1 lg:col-span-2 px-5 flex flex-col justify-between h-full lg:min-h-[60vh] md:min-h-[49vh]'>
            <div className='flex-grow'>
                <h1 className='text-white text-4xl sm:text-5xl lg:text-8xl font-extrabold leading-tight'>
                    <span className='primary-color'>
                    I'm a
                    </span> <br/>
                    <TypeAnimation className=''
                    sequence={[
                        'Fullstack Developer',
                        1000,
                        'iOS App Developer',
                        1000,
                    ]}
                    wrapper="span"
                    speed={50}
                    repeat={Infinity}
                    />
            </h1>
            </div>
            
            <div className='mt-auto'>
                <p className='text-white sm:text-lg my-5 lg:text-xl'>
                I'm a driven software engineer at McMaster University, passionate about full-stack development and building impactful applications.
                </p>

                <div className='my-8'>
                    <a href="/Resume.pdf" className='px-6 py-3 w-full rounded-xl mr-4 bg-primary-color hover:ring ring-offset-30 ring-blue-200 text-white'>
                        View Resume <GrDocumentPdf className='inline-block ml-2'/>
                    </a>
                    <a href="#contact" className='px-6 py-3 w-full rounded-xl border border-gray-400 hover:ring ring-offset-30 ring-blue-200 text-white'>
                        Contact
                    </a>   
                </div>
            </div>
        </div>

    </div>
  )
}

export default Hero